import {createModelSchema, alias} from "serializr";
import {SmartOfferBundle} from "../bundle-core/SmartOfferBundle";
import {SmartOfferBundleKind} from "../bundle-core/SmartOfferBundleKind";
import {RewardTrack} from "@/modules/redactor/models/reward/RewardTrack";
import {PlinkoGameConfig} from "@/modules/redactor/models/smart-offer/bundle-plinko/PlinkoGameConfig";
import {PlinkoExchangeConfig} from "@/modules/redactor/models/smart-offer/bundle-plinko/PlinkoExchangeConfig";


export class SmartOfferBundlePlinko extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.PLINKO);

        this._gameConfig = null;
        this._defaultTrack = null;
        this._premiumTrack = null;
        this._exchangeTrack = null;
        this._exchangeConfig = null;
    }

    get gameConfig() {
        return this._gameConfig;
    }

    set gameConfig(value) {
        this._gameConfig = value;
    }

    get defaultTrack() {
        return this._defaultTrack;
    }

    set defaultTrack(value) {
        this._defaultTrack = value;
    }

    get premiumTrack() {
        return this._premiumTrack;
    }

    set premiumTrack(value) {
        this._premiumTrack = value;
    }

    get exchangeTrack() {
        return this._exchangeTrack;
    }

    set exchangeTrack(value) {
        this._exchangeTrack = value;
    }

    get exchangeConfig() {
        return this._exchangeConfig;
    }

    set exchangeConfig(value) {
        this._exchangeConfig = value;
    }

    valid() {

        if (!this.gameConfig || !this.gameConfig.valid()) {
            return false;
        }

        if (this.defaultTrack && !this.defaultTrack.valid()) {
            return false;
        }

        if (this.premiumTrack && !this.premiumTrack.valid()) {
            return false;
        }

        if (this.exchangeTrack && !this.exchangeTrack.valid()) {
            return false;
        }

        if (this.exchangeConfig && !this.exchangeConfig.valid()) {
            return false;
        }

        return super.valid();
    }

    empty() {

        if (!this.gameConfig) {
            return true;
        }

        return super.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundlePlinko());
        } else if (target instanceof SmartOfferBundlePlinko) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundlePlinko, {
    _gameConfig: alias("game_config", PlinkoGameConfig.schema()),
    _defaultTrack: alias("default_track", RewardTrack.schema()),
    _premiumTrack: alias("premium_track", RewardTrack.schema()),
    _exchangeTrack: alias("exchange_track", RewardTrack.schema()),
    _exchangeConfig: alias("exchange_config", PlinkoExchangeConfig.schema())
});
